import styled, { css } from 'styled-components';

import { mediaQueries } from 'shared/styles';

export const Option = styled.button<{
  $hasMultipleOptions?: boolean;
  $isFixedSize?: boolean;
  $isOutlinedVariant?: boolean;
  $isSelected?: boolean;
  $blank?: boolean;
}>`
  align-items: center;
  appearance: none;
  background: var(--dcm-product-option-bg, #f5f6f7);
  border: none;
  border-radius: ${({ theme }) => theme.customized.radius.sm};
  color: var(--dcm-product-option-text-color, #121516);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  flex: 0 0 96px;
  font-size: 12px;
  justify-content: center;
  line-height: ${13 / 12};
  min-height: 60px;
  padding: 2px;
  position: relative;
  transition: all 0.3s;

  @media ${mediaQueries.medium} {
    min-height: 68px;
  }

  ${({ $hasMultipleOptions }) =>
    !$hasMultipleOptions &&
    css`
      flex-basis: 100%;
    `}

  ${({ $isFixedSize, $hasMultipleOptions }) =>
    $isFixedSize
      ? css`
          flex-basis: 72px;
        `
      : css`
          @media ${mediaQueries.medium} {
            flex-basis: 72px;

            ${!$hasMultipleOptions &&
            css`
              flex-basis: 152px;
            `}
          }
        `}

  ${({ $isOutlinedVariant }) =>
    $isOutlinedVariant
      ? css`
          background: var(--dcm-product-option-bg, #fff);
          border: 1px solid var(--dcm-product-option-border-color, #d2d7da);

          &:hover {
            border-color: var(--dcm-product-detail-muted-color, #646d72);
          }
        `
      : css`
          background: var(--dcm-product-option-bg, #f5f6f7);
          border: none;

          &:hover {
            background: var(--dcm-color-surface-hover, #e3e7e9);
          }
        `}

  ${({ $isSelected }) =>
    $isSelected &&
    css`
      border: 2px solid var(--dct--customized-colors-buttonsLinks);

      &:hover {
        border-color: var(--dct--customized-colors-buttonsLinks);
      }
    `}

  ${({ $blank }) =>
    $blank &&
    css`
      background: var(--dcm-product-option-bg, #fff);
      border: 2px dashed var(--dcm-product-option-border-color, #e3e7e9);
      flex-grow: 0;
    `}

  b {
    display: block;
    font-size: 16px;
    font-weight: 600;
    line-height: ${18 / 16};

    @media ${mediaQueries.medium} {
      font-size: 14px;
    }
  }

  [data-tier-savings] {
    color: var(--dct--customized-colors-discountTag);
    font-size: 10px;
    font-weight: 600;
    line-height: 1.2;
    margin-top: 4px;
    text-align: center;
  }
`;

export const DiscountedPrice = styled.span<{ $hasMultipleOptions?: boolean }>`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 10px;
  gap: 2px;
  justify-content: center;
  line-height: 1;
  margin-top: 4px;

  ${({ $hasMultipleOptions }) =>
    $hasMultipleOptions &&
    css`
      @media ${mediaQueries.medium} {
        flex-direction: column;
      }
    `}
`;

export const OriginalPrice = styled.span<{ $listPriceEnabled?: boolean; $hideStrikethrough?: boolean }>`
  color: ${({ $listPriceEnabled }) =>
    $listPriceEnabled
      ? 'var(--dcm-product-detail-muted-color)'
      : 'var(--dcm-product-price-strikethrough-color, #485055)'};
  display: block;
  text-decoration: ${({ $hideStrikethrough }) => ($hideStrikethrough ? 'none' : 'line-through')};
`;

export const Discount = styled.div<{ $listPriceEnabled?: boolean }>`
  color: ${({ $listPriceEnabled }) =>
    $listPriceEnabled ? 'var(--dcm-product-discount-color, #d34a4a)' : 'var(--dct--customized-colors-discountTag)'};
  font-weight: 600;
  white-space: nowrap;
`;

export const Add = styled.span`
  align-items: center;
  background: var(--dct--customized-colors-buttonsLinks);
  border-radius: 50%;
  color: var(--dcm-color-text-inverted, #fff);
  display: flex;
  height: 20px;
  justify-content: center;
  position: absolute;
  right: -6px;
  top: -6px;
  width: 20px;
`;
